(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ALCE-Lunaabout"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('alce-luna-about')) {
    customElements.define('alce-luna-about', class extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', this.handleClick);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);
      }

      handleClick = (event) => {
        const trigger = event.target.closest('[data-load-video]');
        if (!trigger || !this.contains(trigger)) return;

        const slot = trigger.closest('[data-video-slot]');
        const template = slot?.querySelector('[data-video-template]');
        if (!slot || !template) return;

        const fragment = template.content.cloneNode(true);
        const video = fragment.querySelector('video');
        trigger.replaceWith(fragment);
        template.remove();
        video?.play().catch(() => {});
      };
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ALCE-Lunahero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('alce-luna-hero')) {
    customElements.define('alce-luna-hero', class extends HTMLElement {
      connectedCallback() {
        if (this.cleanupTimer) {
          window.clearTimeout(this.cleanupTimer);
          this.cleanupTimer = null;
        }

        this.video = this.querySelector('video');
        if (!this.video) return;

        this.video.controls = false;
        this.video.removeAttribute('controls');
        this.video.muted = true;
        this.video.defaultMuted = true;
        this.video.setAttribute('muted', '');

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.video.removeAttribute('autoplay');
          this.video.pause();
        }
      }

      disconnectedCallback() {
        this.cleanupTimer = window.setTimeout(() => {
          if (this.isConnected || !this.video) return;

          this.video.pause();
          this.video.removeAttribute('autoplay');
          this.video.removeAttribute('src');
          this.video.querySelectorAll('source').forEach((source) => source.removeAttribute('src'));
          this.video.load();
          this.video = null;
          this.cleanupTimer = null;
        }, 0);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ALCE-header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  const updateCustomerNavigationState = (session = null) => {
    document.querySelectorAll('[data-alce-customer-aware="true"]').forEach((button) => {
      const authenticated = button.dataset.alceServerCustomer === 'true' || Boolean(session?.authenticated);
      const label = authenticated
        ? button.dataset.alceLoggedInLabel
        : button.dataset.alceGuestLabel;
      const href = authenticated
        ? button.dataset.alceLoggedInUrl
        : button.dataset.alceGuestUrl;
      const labelElement = button.querySelector('[data-alce-button-label]');

      if (labelElement && label) labelElement.textContent = label;
      if (href) button.href = href;
      if (label) {
        button.setAttribute('aria-label', label);
        button.setAttribute('title', label);
      }
      button.dataset.alceCustomerState = authenticated ? 'authenticated' : 'guest';
    });

    document.querySelectorAll('[data-alce-hide-when-logged-in="true"]').forEach((item) => {
      const authenticated = item.dataset.alceServerCustomer === 'true' || Boolean(session?.authenticated);
      item.hidden = authenticated;
      item.setAttribute('aria-hidden', String(authenticated));
    });
  };

  window.addEventListener('alce:b2b-session', (event) => {
    updateCustomerNavigationState(event.detail);
  });

  updateCustomerNavigationState(window.AlceB2BSession?.current);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ALCE-luna"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('alce-luna-section')) {
    customElements.define('alce-luna-section', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';
        this.tabs = Array.from(this.querySelectorAll('[data-category-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-category-panel]'));
        this.panelsContainer = this.querySelector('.alce-luna__panels');
        this.liveRegion = this.querySelector('[data-live-region]');
        this.picker = this.querySelector('[data-picker]');
        this.pickerWrap = this.querySelector('.alce-luna__picker-wrap');
        this.abortController = new AbortController();
        const signal = this.abortController.signal;

        this.addEventListener('click', (event) => this.onClick(event), { signal });
        this.addEventListener('keydown', (event) => this.onKeydown(event), { signal });
        this.addEventListener('submit', (event) => this.onSubmit(event), { capture: true, signal });
        document.addEventListener('shopify:block:select', (event) => this.onBlockSelect(event), { signal });
        if (this.picker) {
          this.picker.addEventListener('scroll', () => this.updatePickerOverflow(), { passive: true, signal });
          window.addEventListener('resize', () => this.updatePickerOverflow(), { passive: true, signal });
          requestAnimationFrame(() => this.updatePickerOverflow());
        }
        window.addEventListener('alce:b2b-session', () => this.applyAudiencePrices(), { signal });
        this.priceStateObserver = new MutationObserver(() => this.applyAudiencePrices());
        this.priceStateObserver.observe(document.documentElement, {
          attributes: true,
          attributeFilter: ['data-alce-b2b-session', 'data-alce-b2b-account-status', 'data-alce-b2b-can-purchase']
        });
        this.priceObserver = new MutationObserver(() => this.queuePriceNormalization());
        this.priceObserver.observe(this, { childList: true, characterData: true, subtree: true });
        this.applyAudiencePrices();
        this.normalizePrices();
      }

      disconnectedCallback() {
        if (this.abortController) this.abortController.abort();
        if (this.priceStateObserver) this.priceStateObserver.disconnect();
        if (this.priceObserver) this.priceObserver.disconnect();
        this.dataset.initialized = 'false';
      }

      onClick(event) {
        const tab = event.target.closest('[data-category-tab]');
        if (!tab || !this.contains(tab)) return;
        this.activateTab(tab, false);
      }

      onKeydown(event) {
        const tab = event.target.closest('[data-category-tab]');
        if (!tab || !this.contains(tab)) return;
        const index = this.tabs.indexOf(tab);
        if (index < 0) return;

        let nextIndex = null;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (index + 1) % this.tabs.length;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = this.tabs.length - 1;
        if (nextIndex === null) return;

        event.preventDefault();
        this.activateTab(this.tabs[nextIndex], true);
      }

      onBlockSelect(event) {
        if (!event.target || !this.contains(event.target)) return;
        const blockId = event.detail && event.detail.blockId ? event.detail.blockId : event.target.dataset.blockId;
        const tab = this.tabs.find((item) => item.dataset.blockId === blockId);
        if (tab) this.activateTab(tab, false);
      }

      updatePickerOverflow() {
        if (!this.picker || !this.pickerWrap) return;
        const maxScroll = Math.max(0, this.picker.scrollWidth - this.picker.clientWidth);
        const hasOverflow = maxScroll > 8;
        const atStart = this.picker.scrollLeft <= 4;
        const atEnd = this.picker.scrollLeft >= maxScroll - 4;

        this.pickerWrap.classList.toggle('has-overflow', hasOverflow);
        this.pickerWrap.classList.toggle('is-at-start', atStart);
        this.pickerWrap.classList.toggle('is-at-end', atEnd);
      }

      activateTab(tab, focusTab) {
        if (!tab || tab.getAttribute('aria-selected') === 'true') {
          if (focusTab && tab) tab.focus();
          return;
        }

        const update = () => {
          const showAll = tab.hasAttribute('data-show-all');
          this.tabs.forEach((item) => {
            const active = item === tab;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-selected', String(active));
            item.tabIndex = active ? 0 : -1;
          });

          if (this.panelsContainer) this.panelsContainer.classList.toggle('is-show-all', showAll);
          this.panels.forEach((panel) => {
            panel.hidden = !showAll && panel.id !== tab.getAttribute('aria-controls');
          });
        };

        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (this.dataset.enableTransitions === 'true' && !reduceMotion && document.startViewTransition) {
          document.startViewTransition(update);
        } else {
          update();
        }

        tab.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'nearest', inline: 'center' });
        requestAnimationFrame(() => this.updatePickerOverflow());
        if (focusTab) tab.focus();

        const label = tab.querySelector('.alce-luna__category-label');
        if (this.liveRegion && label) this.liveRegion.textContent = label.textContent.trim();

        this.dispatchEvent(new CustomEvent('alce-luna:category-change', {
          bubbles: true,
          detail: {
            blockId: tab.dataset.blockId,
            panelId: tab.getAttribute('aria-controls')
          }
        }));
        this.normalizePrices();
      }

      hasApprovedB2BSession() {
        const root = document.documentElement;
        return root.dataset.alceB2bSession === 'authenticated'
          && root.dataset.alceB2bAccountStatus === 'approved'
          && root.dataset.alceB2bCanPurchase === 'true';
      }

      applyAudiencePrices() {
        const useB2BPrice = this.hasApprovedB2BSession();
        this.querySelectorAll('.alce-luna__product[data-alce-b2c-public="true"]').forEach((card) => {
          const price = card.querySelector('[data-alce-visible-price]');
          if (!price) return;

          const publicPrice = card.dataset.alcePublicPrice || '';
          const publicComparePrice = card.dataset.alcePublicComparePrice || '';
          const b2bPrice = card.dataset.alceB2bPrice || '';
          const showB2BPrice = useB2BPrice && b2bPrice.trim() !== '';
          const activePrice = showB2BPrice ? b2bPrice : publicPrice;
          const activeComparePrice = showB2BPrice ? '' : publicComparePrice;

          if (activePrice) price.textContent = activePrice;
          card.dataset.alcePriceMode = showB2BPrice
            ? 'b2b-ex-vat'
            : card.dataset.alceB2cPriceExcludesVat === 'true' ? 'public-ex-vat' : 'public';

          const comparePrice = card.querySelector('[data-alce-visible-compare-price]');
          if (comparePrice) {
            comparePrice.textContent = activeComparePrice;
            comparePrice.hidden = activeComparePrice === '';
          }
        });
        this.normalizePrices();
      }

      cleanPriceText(rawValue) {
        const raw = String(rawValue || '').replace(/\s+/g, ' ').trim();
        const match = raw.match(/(-?\d[\d\s\u00A0\u202F.]*(?:,\d+)?)\s*kr\b/i);
        if (!match) return raw;
        let numeric = match[1].replace(/[\s\u00A0\u202F]/g, '');

        if (numeric.includes(',')) {
          numeric = numeric.replace(/\./g, '').replace(',', '.');
        } else if (/\.\d{1,2}$/.test(numeric)) {
          const parts = numeric.split('.');
          const decimals = parts.pop();
          numeric = `${parts.join('')}.${decimals}`;
        } else {
          numeric = numeric.replace(/\./g, '');
        }

        const amount = Number(numeric);
        if (!Number.isFinite(amount)) return raw;
        return `${new Intl.NumberFormat('nb-NO', { maximumFractionDigits: 2, minimumFractionDigits: 0 }).format(amount)} kr`;
      }

      normalizePrices() {
        this.querySelectorAll('.alce-luna__price, .alce-luna__compare-price, .alce-b2b-card__price').forEach((price) => {
          const normalized = this.cleanPriceText(price.textContent);
          if (normalized && normalized !== price.textContent.trim()) price.textContent = normalized;
        });
      }

      queuePriceNormalization() {
        if (this.priceNormalizationQueued) return;
        this.priceNormalizationQueued = true;
        requestAnimationFrame(() => {
          this.priceNormalizationQueued = false;
          this.normalizePrices();
        });
      }

      async onSubmit(event) {
        const form = event.target.closest('form.alce-luna__product-form');
        if (!form || !this.contains(form)) return;
        const button = event.submitter || form.querySelector('[type="submit"]');
        if (!button || button.disabled || button.classList.contains('is-loading')) return;
        const formData = new FormData(form);
        if (!formData.get('id')) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        const errorMessage = form.querySelector('.alce-luna__form-error');
        const cartSurface = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        let sectionsToRender = [];

        if (cartSurface && typeof cartSurface.getSectionsToRender === 'function') {
          sectionsToRender = cartSurface.getSectionsToRender();
        }

        const sectionIds = sectionsToRender.map((item) => item.section || item.id).filter(Boolean);
        if (!sectionIds.includes('cart-icon-bubble')) sectionIds.push('cart-icon-bubble');
        formData.delete('sections');
        formData.delete('sections_url');
        formData.append('sections', sectionIds.join(','));
        formData.append('sections_url', window.location.pathname);

        button.classList.add('is-loading');
        button.setAttribute('aria-disabled', 'true');
        button.disabled = true;
        if (errorMessage) errorMessage.hidden = true;

        try {
          const baseAddUrl = window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add';
          const addUrl = baseAddUrl.endsWith('.js') ? baseAddUrl : `${baseAddUrl}.js`;
          const response = await fetch(addUrl, {
            method: 'POST',
            credentials: 'same-origin',
            headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: formData
          });
          const result = await response.json();
          if (!response.ok || result.status) throw new Error(result.description || result.message || `Add to cart failed (${response.status})`);

          this.replaceCartIconSection(result.sections);
          if (cartSurface && typeof cartSurface.renderContents === 'function' && result.sections) cartSurface.renderContents(result);
          const cart = await this.fetchCartState();
          this.updateCartCount(cart);

          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart } }));
          document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart, source: 'alce-luna' } }));

          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'alce-luna', cartData: cart });
          }
        } catch (error) {
          if (errorMessage) {
            errorMessage.textContent = error.message;
            errorMessage.hidden = false;
          }
        } finally {
          button.classList.remove('is-loading');
          button.removeAttribute('aria-disabled');
          button.disabled = false;
        }
      }

      replaceCartIconSection(sections) {
        const html = sections && sections['cart-icon-bubble'];
        const currentIcon = document.getElementById('cart-icon-bubble');
        if (!html || !currentIcon) return;
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const refreshedIcon = parsed.getElementById('cart-icon-bubble');
        if (refreshedIcon) currentIcon.innerHTML = refreshedIcon.innerHTML;
      }

      async fetchCartState() {
        const cartUrl = window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart';
        const stateUrl = cartUrl.endsWith('.js') ? cartUrl : `${cartUrl}.js`;
        const response = await fetch(stateUrl, {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
          cache: 'no-store'
        });
        if (!response.ok) throw new Error(`Cart refresh failed (${response.status})`);
        return response.json();
      }

      updateCartCount(cart) {
        if (!cart || typeof cart.item_count !== 'number') return;
        document.querySelectorAll('.cart-count-bubble').forEach((bubble) => {
          bubble.classList.toggle('hidden', cart.item_count < 1);
          bubble.hidden = cart.item_count < 1;
          const visibleCount = bubble.querySelector('span[aria-hidden="true"]') || bubble.querySelector('span');
          if (visibleCount) visibleCount.textContent = String(cart.item_count);
          const accessibleCount = bubble.querySelector('.visually-hidden');
          if (accessibleCount) accessibleCount.textContent = `${cart.item_count} produkter i handlekurven`;
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ALCELunahero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('alce-luna-hero')) {
    customElements.define('alce-luna-hero', class extends HTMLElement {
      connectedCallback() {
        const video = this.querySelector('video[data-autoplay]');
        if (!video) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          video.removeAttribute('autoplay');
          video.pause();
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  const updateCustomerNavigationState = (session = null) => {
    document.querySelectorAll('[data-alce-customer-aware="true"]').forEach((button) => {
      const authenticated = button.dataset.alceServerCustomer === 'true' || Boolean(session?.authenticated);
      const label = authenticated
        ? button.dataset.alceLoggedInLabel
        : button.dataset.alceGuestLabel;
      const href = authenticated
        ? button.dataset.alceLoggedInUrl
        : button.dataset.alceGuestUrl;
      const labelElement = button.querySelector('[data-alce-button-label]');

      if (labelElement && label) labelElement.textContent = label;
      if (href) button.href = href;
      if (label) {
        button.setAttribute('aria-label', label);
        button.setAttribute('title', label);
      }
      button.dataset.alceCustomerState = authenticated ? 'authenticated' : 'guest';
    });

    document.querySelectorAll('[data-alce-hide-when-logged-in="true"]').forEach((item) => {
      const authenticated = item.dataset.alceServerCustomer === 'true' || Boolean(session?.authenticated);
      item.hidden = authenticated;
      item.setAttribute('aria-hidden', String(authenticated));
    });
  };

  window.addEventListener('alce:b2b-session', (event) => {
    updateCustomerNavigationState(event.detail);
  });

  updateCustomerNavigationState(window.AlceB2BSession?.current);

  } catch(e) { console.error(e); }
})();
})();
